// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overclaim-item-bottom-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: fit-content;
}
.overclaim-item-bottom-section .overclaim-item-bottom-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  align-items: center;
}
.overclaim-item-bottom-section .overclaim-item-bottom-content .options-row {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: fit-content;
  margin-bottom: 5rem;
}
.overclaim-item-bottom-section .overclaim-item-bottom-content h5 {
  display: flex;
  width: 100%;
  margin-top: 3rem;
  margin-bottom: 1.5rem;
  align-items: flex-start;
}
.overclaim-item-bottom-section .overclaim-item-bottom-content .button-component {
  padding-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/OverclaimView/DisputeOptionSection/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACN;AAEI;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;AAAN;AAGI;EACE,oBAAA;AADN","sourcesContent":[".overclaim-item-bottom-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: fit-content;\n\n  .overclaim-item-bottom-content {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: fit-content;\n    align-items: center;\n\n    .options-row {\n      display: flex;\n      width: 100%;\n      justify-content: space-between;\n      height: fit-content;\n      margin-bottom: 5rem;\n    }\n\n    h5 {\n      display: flex;\n      width: 100%;\n      margin-top: 3rem;\n      margin-bottom: 1.5rem;\n      align-items: flex-start;\n    }\n\n    .button-component {\n      padding-left: 0.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
